import Validator from '@/shared/utils/validator'
import { User } from '../user'

async function login(data, networkRepo, localRepo) {
  Validator.requireObject('data', data)
  Validator.require('email', data.email, 'string')
  Validator.require('password', data.password, 'string')
  const { email, password } = data
  const user = new User()
  user.setEmail(email)
  user.setPassword(password)

  const response = await networkRepo.login(user)
  console.log('🚀 ~ login ~ response:', response)
  Validator.requireObject(response, data)
  Validator.require('id', response.id, 'string')
  Validator.require('email', response.email, 'string')
  Validator.require('firstName', response.firstName, 'string')
  Validator.require('lastName', response.lastName, 'string')
  Validator.requireObject('metadata', response.metadata ?? {})

  user.setData(response)
  await localRepo.save(user)
  return user
}

export default login
